import { render, staticRenderFns } from "./RegionNewEventPage.vue?vue&type=template&id=2263c02a&"
import script from "./RegionNewEventPage.vue?vue&type=script&lang=js&"
export * from "./RegionNewEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports